<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="模板名称" prop="templateName">
                <el-input v-model="queryCondition.templateName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="GRI编码" prop="griCode">
                <el-input v-model="queryCondition.griCode" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="类型" prop="templateType">
                <ic-select table="TT_PROC_TEMPLATE" field="TPLTYPE" clearable v-model="queryCondition.templateType" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态" prop="status">
                <ic-select table="TT_PROC_TEMPLATE" field="STATUS" clearable v-model="queryCondition.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onAdd" v-acl="PROC_TPL_MANAGE_MAINTAIN">新增模板</el-button>
      </el-row>
      <el-row>
        <el-table :data="tableData" max-height="425" border stripe style="width: 100%">
          <el-table-column prop="templateCode" sortable :sort-method="(a,b) => sortMethods(a ,b , 'templateCode')" label="模板编码" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="templateName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'templateName')" label="模板名称" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text" @click="onDetail(scope.row)">{{ scope.row.templateName}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="templateVersion" sortable :sort-method="(a,b) => sortMethods(a ,b , 'templateVersion')" label="版本号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="griCode" sortable :sort-method="(a,b) => sortMethods(a ,b , 'griCode')" label="GRI编码" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="category1Name" sortable :sort-method="(a,b) => sortMethods(a ,b , 'category1')" label="Category1" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="category2Name" sortable :sort-method="(a,b) => sortMethods(a ,b , 'category2')" label="Category2" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="category3Name" sortable :sort-method="(a,b) => sortMethods(a ,b , 'category3')" label="Category3" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="griName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'griName')" label="GRI名称" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="templateType" sortable :sort-method="(a,b) => sortMethods(a ,b , 'templateType')" label="类型" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :type="scope.row.templateType === 'L' ? 'success' : 'warning'">
                {{ scope.row.templateTypeText}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" sortable :sort-method="(a,b) => sortMethods(a ,b , 'status')" label="状态" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'DRAFT' ? 'warning' :scope.row.status === 'ACTIVE'?'success': 'danger'">
                {{ scope.row.statusText}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'createUserName')" label="创建人" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createDate" sortable :sort-method="(a,b) => sortMethods(a ,b , 'createDate')" label="创建时间" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="updateUserName" sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateUserName')" label="更新人" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="updateDate" sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateDate')" label="更新时间" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="onUpdate(scope.row)" v-if="scope.row.isLatest=='1'&&scope.row.status=='ACTIVE'" v-acl="PROC_TPL_MANAGE_MAINTAIN">升版</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
          </el-pagination>
        </div>
      </el-row>
    </div>

  </div>
</template>
<script>
import processApi from "@/api/Process/index";
import paginationMixin from '@/mixins/pagitionMixin';
import IcSelect from "@/components/common/icSelect";
export default {
  name: 'Window',
  mixins: [paginationMixin],
  components: { IcSelect },
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        templateName: "",
        griCode: "",
        templateType: "",
        status: "",
      },
      totalCount: 0,
      pages: 1,
      tableData: [],
      categoryOptions: [],
    };
  },
  mounted() {
    this.queryData()
    this.getProcessCategory()
  },
  methods: {
    queryData() {
      processApi.getProcessTemplateList(this.queryCondition).then(res => {
        console.log("🚀 ~ queryData ~ res:", res)
        if (res.code == '200') {
          this.tableData = res.data.records
          this.totalCount = res.data.total
        }
      })
    },
    getProcessCategory() {
      processApi.getProcessCategory().then(res => {
        console.log("🚀 ~ getProcessCategory ~ res:", res)
        res.data.forEach(ele => {
          this.categoryOptions.push({
            label: ele.categoryCode + '-' + ele.categoryName,
            value: ele.categoryId
          })
        })
      })
    },
    onAdd() {
      this.$router.push({
        path: "/process-monitoring/template/detail",
        query: {
          type: "add"
        }
      })
    },
    onDetail(row) {
      var type = ''
      if (row.status == 'DRAFT') {
        type = 'edit'
      } else {
        type = 'view'
      }
      this.$router.push({
        path: "/process-monitoring/template/detail",
        query: {
          type: type,
          tplId: row.tplId
        }
      })
    },
    onUpdate(row) {
      processApi.updateTemplateVersion(row.tplId).then(res => {
        console.log("🚀 ~ onUpdate ~ res:", res)
        if (res.code == '200') {
          this.$message.success('升版成功')
          this.queryData()
        }
      })
    },
    onSearch() {
      this.queryCondition.pageNum = 1;
      this.queryData()
    },
    onReset() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        templateName: "",
        griCode: "",
        templateType: "",
        status: "",
      }
      this.queryData()
    },
    sortMethods(a, b, proptype) {
      var prop
      if (proptype === 'updateDate') {
        prop = 'updateDateMiss'
      } else {
        prop = proptype
      }
      if (a[prop] === null || a[prop] === undefined) {
        return 1; // 将空值排在后面
      } else if (b[prop] === null || b[prop] === undefined) {
        return -1; // 将空值排在后面
      } else {
        // 自定义排序逻辑
        // return a[prop] - b[prop]; // 示例中使用数字类型的比较
        if (typeof a[prop] === 'string' && typeof b[prop] === 'string') {
          return a[prop].localeCompare(b[prop])
        } else {
          return a[prop] - b[prop];
        }
      }
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  }
}
</script>
  